(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
/* Collection Studio: progressive enhancement, one DOM card per product. */
(() => {
  'use strict';
  if (customElements.get('collection-studio')) return;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const mod = (value, size) => ((value % size) + size) % size;

  class CollectionStudio extends HTMLElement {
    connectedCallback() {
      this.bootFrame = requestAnimationFrame(() => this.boot());
    }

    boot() {
      if (!this.isConnected || this.initialized) return;
      const configNode = this.querySelector('[data-cs-config]');
      this.stage = this.querySelector('.cs-stage');
      this.track = this.querySelector('.cs-track');
      this.slides = Array.from(this.querySelectorAll('.cs-track > .cs-slide'));
      const expected = Number(this.dataset.count || this.slides.length);
      if (!configNode || !this.stage || !this.slides.length || this.slides.length < expected) {
        if (expected > 0 && !this.markupObserver) {
          this.markupObserver = new MutationObserver(() => {
            cancelAnimationFrame(this.bootFrame);
            this.bootFrame = requestAnimationFrame(() => this.boot());
          });
          this.markupObserver.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      this.markupObserver?.disconnect();
      this.markupObserver = null;
      try { this.config = JSON.parse(configNode.textContent); }
      catch (error) { console.warn('Collection Studio: native scrolling is available.', error); return; }
      this.initialized = true;
      this.life = new AbortController();
      this.count = this.slides.length;
      this.circular = !!this.config.loop && this.count > 2;
      this.active = 0;
      this.position = 0;
      this.target = 0;
      this.frame = 0;
      this.paintFrame = 0;
      this.resizeFrame = 0;
      this.glowFrame = 0;
      this.blockClickUntil = 0;
      this.lastWheel = 0;
      this.wheelTotal = 0;
      this.wheelSign = 0;
      this.wheelLocked = false;
      this.drag = null;
      this.dragLife = null;
      this.needsMeasure = false;
      this.stageHeight = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.dots = Array.from(this.querySelectorAll('[data-goto]'));
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.counter = this.querySelector('[data-cs-current]');
      this.progress = this.querySelector('[data-cs-progress]');
      this.status = this.querySelector('[data-cs-status]');
      this.activeTitle = this.querySelector('[data-cs-active-title]');
      this.cards = this.slides.map(slide => slide.querySelector('.cs-card'));
      this.media = this.cards.map(card => Array.from(card.querySelectorAll('.card__media img')));
      this.previewTimer = 0;
      this.productPreviews = this.config.galleryPreview
        ? this.cards.map((card, index) => this.setupProductPreview(card, index))
        : this.cards.map(() => null);
      this.renderState = this.slides.map(() => ({}));
      this.glow = this.querySelector('.cs-glow');
      this.tabStops = new Map();
      this.cards.forEach(card => {
        card.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach(node => {
          this.tabStops.set(node, node.getAttribute('tabindex'));
        });
      });
      this.moveModals();
      this.setAttribute('data-ready', '');
      this.toggleAttribute('data-swipe', !!this.config.swipe && this.count > 1);
      this.measure();
      this.commit(false);

      const on = (target, type, fn, options = {}) => {
        target.addEventListener(type, fn, { ...options, signal: this.life.signal });
      };
      on(this, 'click', event => this.onClick(event), { capture: true });
      on(this, 'keydown', event => this.onKey(event));
      // A fresh press is a new interaction, not a click left over from a swipe.
      on(this, 'pointerdown', event => {
        if (event.isPrimary) this.blockClickUntil = 0;
      }, { capture: true });
      on(this.stage, 'pointerdown', event => this.pointerDown(event), { capture: true });
      on(this.stage, 'lostpointercapture', event => {
        // Ignore a child losing implicit capture when capture moves to the stage.
        if (event.target === this.stage) this.pointerUp(event, true);
      });
      on(window, 'blur', () => this.settleImmediately());
      on(this.stage, 'dragstart', event => {
        if (this.config.swipe) event.preventDefault();
      });
      on(this.stage, 'wheel', event => this.onWheel(event), { passive: false });
      on(this, 'pointermove', event => this.followGlow(event), { passive: true });
      on(this, 'pointerleave', () => {
        this.resetGlow();
      });
      on(window, 'resize', () => this.queueMeasure(), { passive: true });
      on(this.motion, 'change', () => {
        if (this.motion.matches) this.settleImmediately();
        this.paint();
        this.syncProductPreview();
      });
      on(document, 'visibilitychange', () => {
        if (document.hidden) {
          this.stopProductPreview();
          this.settleImmediately();
        } else {
          this.syncProductPreview();
        }
      });
      on(this.finePointer, 'change', () => { this.resetGlow(); this.paint(); });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueMeasure());
        this.resizeObserver.observe(this.stage);
        this.cards.forEach(card => this.resizeObserver.observe(card));
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => { if (this.isConnected && this.initialized) this.queueMeasure(); });
      }
    }

    productImageKey(url) {
      if (!url) return '';
      try { return new URL(url, window.location.href).pathname; }
      catch (_) { return String(url).split('?')[0]; }
    }

    setupProductPreview(card, index) {
      if (!card) return null;
      const media = card.querySelector('.card__media .media') || card.querySelector('.card__media');
      if (!media) return null;
      const originals = Array.from(media.querySelectorAll(':scope > img'));
      const base = originals[0];
      if (!base) return null;

      const baseKey = this.productImageKey(base.currentSrc || base.src);
      const seen = new Set(baseKey ? [baseKey] : []);
      const sources = [];
      card.querySelectorAll('[data-cs-product-image-src]').forEach(node => {
        const src = node.dataset.src || '';
        const key = this.productImageKey(src);
        if (!src || (key && seen.has(key))) return;
        if (key) seen.add(key);
        sources.push({ src, srcset: node.dataset.srcset || '' });
      });
      if (!sources.length) return null;

      base.classList.add('cs-product-preview-base');
      originals.slice(1).forEach(image => image.classList.add('cs-product-preview-secondary'));
      return { index, card, media, base, sources, images: [], dots: [], frame: 0, ready: false };
    }

    ensureProductPreview(state) {
      if (!state || state.ready) return;
      const size = `${Math.ceil(this.cardWidth || state.card.offsetWidth || 500)}px`;
      state.sources.forEach(source => {
        const image = document.createElement('img');
        image.className = 'cs-product-preview-image';
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = size;
        if (source.srcset) image.srcset = source.srcset;
        image.src = source.src;
        state.media.appendChild(image);
        state.images.push(image);
      });

      if (this.config.galleryDots && state.images.length) {
        const dots = document.createElement('span');
        dots.className = 'cs-product-preview-dots';
        dots.setAttribute('aria-hidden', 'true');
        for (let i = 0; i <= state.images.length; i += 1) {
          const dot = document.createElement('i');
          dot.className = `cs-product-preview-dot${i === 0 ? ' is-active' : ''}`;
          dots.appendChild(dot);
          state.dots.push(dot);
        }
        state.media.appendChild(dots);
      }
      state.ready = true;
    }

    showProductPreview(state, frame = 0) {
      if (!state) return;
      this.ensureProductPreview(state);
      const total = state.images.length + 1;
      if (total <= 1) return;
      state.frame = mod(Number(frame) || 0, total);
      state.images.forEach((image, imageIndex) => {
        image.classList.toggle('is-visible', state.frame === imageIndex + 1);
      });
      state.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', state.frame === dotIndex);
      });
    }

    stopProductPreview() {
      if (!this.previewTimer) return;
      window.clearInterval(this.previewTimer);
      this.previewTimer = 0;
    }

    resetProductPreview(state) {
      if (!state) return;
      state.frame = 0;
      if (!state.ready) return;
      state.images.forEach(image => image.classList.remove('is-visible'));
      state.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === 0));
    }

    syncProductPreview() {
      this.stopProductPreview();
      if (!this.config.galleryPreview || !this.productPreviews?.length) return;
      this.productPreviews.forEach((state, index) => {
        if (state && index !== this.active) this.resetProductPreview(state);
      });
      const state = this.productPreviews[this.active];
      if (!state) return;
      if (this.motion.matches || document.hidden) {
        this.resetProductPreview(state);
        return;
      }
      this.showProductPreview(state, 0);
      if (state.images.length < 1) return;
      const interval = clamp(Number(this.config.galleryInterval) || 3000, 1200, 8000);
      this.previewTimer = window.setInterval(() => {
        if (!this.isConnected || this.frame || this.drag?.moving || document.hidden) return;
        this.showProductPreview(state, state.frame + 1);
      }, interval);
    }

    // Keep variant dialogs outside transformed/clipped cards. Namespaced IDs
    // are produced in Liquid, including when the same product occurs elsewhere.
    moveModals() {
      this.modalRecords = [];
      const seen = new Set();
      this.querySelectorAll('modal-opener[data-modal]').forEach(opener => {
        const id = (opener.dataset.modal || '').replace(/^#/, '');
        const modal = document.getElementById(id);
        if (!modal || seen.has(modal) || !modal.matches('quick-add-modal, modal-dialog')) return;
        seen.add(modal);
        const marker = document.createComment('Collection Studio dialog location');
        if (this.contains(modal)) modal.before(marker);
        else opener.after(marker);
        this.modalRecords.push({ modal, marker });
        modal.dataset.csOwner = this.id;
        if (modal.parentElement !== document.body) document.body.appendChild(modal);
      });
    }

    queueMeasure() {
      if (this.resizeFrame) return;
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = 0;
        if (!this.isConnected || !this.initialized) return;
        if (this.drag?.moving) { this.needsMeasure = true; return; }
        this.measure();
      });
    }

    measure() {
      const style = getComputedStyle(this);
      this.direction = style.direction === 'rtl' ? -1 : 1;
      this.cardWidth = this.slides[0].offsetWidth;
      this.stageWidth = this.stage.clientWidth;
      this.stepSize = Math.max(80, this.cardWidth * (parseFloat(style.getPropertyValue('--cs-spread')) || 0.94));
      const padding = parseFloat(style.getPropertyValue('--cs-stage-pad')) || 36;
      const height = Math.max(...this.cards.map(card => card.offsetHeight), 100);
      const stageHeight = Math.ceil(height + padding * 2 + Number(this.config.lift || 0));
      if (stageHeight !== this.stageHeight) {
        this.stageHeight = stageHeight;
        this.style.setProperty('--cs-stage-height', `${stageHeight}px`);
      }
      const sizes = `${Math.ceil(this.cardWidth)}px`;
      this.media.forEach(images => images.forEach(img => {
        if (img.sizes !== sizes) img.sizes = sizes;
      }));
      this.needsMeasure = false;
      this.paint();
    }

    distance(index, position = this.position) {
      const raw = index - position;
      return this.circular ? mod(raw + this.count / 2, this.count) - this.count / 2 : raw;
    }

    paint() {
      if (!this.initialized || !this.cardWidth) return;
      const cfg = this.config;
      const reduced = this.motion.matches;
      const flat = cfg.effect === 'flat' || reduced;
      const moving = !!this.frame || !!this.drag?.moving;
      // Rasterizing a changing blur over every product is expensive. Keep the
      // configured blur only at rest, on devices with a fine/hover pointer.
      const useBlur = !moving && !reduced && this.finePointer.matches && Number(cfg.blur) > 0;
      const depthAmount = Number(cfg.depth) || 0;
      const rotation = Number(cfg.rotation) || 0;
      const lift = Number(cfg.lift) || 0;
      const scaleAmount = (100 - Number(cfg.sideScale)) / 100;
      const sideAlpha = Number(cfg.sideOpacity) / 100;
      const sides = Number(cfg.sides) || 1;
      this.slides.forEach((slide, index) => {
        const state = this.renderState[index];
        const setStyle = (name, value) => {
          if (state[name] !== value) {
            slide.style[name] = value;
            state[name] = value;
          }
        };
        const setClass = (name, enabled) => {
          if (state[name] !== enabled) {
            slide.classList.toggle(name, enabled);
            state[name] = enabled;
          }
        };
        const d = this.distance(index);
        const a = Math.abs(d);
        const amount = Math.min(a, 1);
        const edgeFade = clamp(sides + 1 - a, 0, 1);
        const wrapFade = this.circular ? clamp((this.count / 2 - a) / 0.45, 0, 1) : 1;
        const opacity = (1 - amount * (1 - sideAlpha)) * edgeFade * wrapFade;
        if (opacity < 0.005) {
          setStyle('visibility', 'hidden');
          setStyle('opacity', '0');
          setStyle('pointerEvents', 'none');
          setStyle('filter', 'none');
          setClass('is-selectable', false);
          setClass('is-moving', false);
          // No transforms, image queries, or blur calculations for hidden cards.
          return;
        }
        const x = d * this.stepSize * this.direction;
        const depth = flat ? 0 : -Math.min(a, 3) * depthAmount;
        const rotateY = flat || cfg.effect === 'arc' ? 0 : -clamp(d, -1.5, 1.5) * rotation * this.direction;
        const rotateZ = cfg.effect === 'arc' && !reduced ? clamp(d, -2, 2) * rotation * 0.25 * this.direction : 0;
        const y = flat ? 0 : amount * lift + (cfg.effect === 'arc' ? a * a * 9 : 0);
        const scale = Math.max(0.45, 1 - Math.min(a, 2.5) * scaleAmount);
        setStyle('transform', `translateX(-50%) translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, ${depth.toFixed(2)}px) rotateY(${rotateY.toFixed(2)}deg) rotateZ(${rotateZ.toFixed(2)}deg) scale(${scale.toFixed(4)})`);
        setStyle('opacity', opacity.toFixed(3));
        setStyle('filter', useBlur ? `blur(${(Math.min(a, 2) * Number(cfg.blur)).toFixed(2)}px)` : 'none');
        setStyle('zIndex', String(100 - Math.min(90, Math.round(a * 10))));
        setStyle('visibility', 'visible');
        const selectable = !!cfg.sideClick && index !== this.active && opacity > 0.08;
        setClass('is-selectable', selectable);
        setClass('is-moving', moving);
        setStyle('pointerEvents', index === this.active || selectable ? 'auto' : 'none');
        if (opacity > 0.08 && !state.imagesReady) {
          this.media[index].forEach(img => {
            if (img.loading === 'lazy') img.loading = 'eager';
          });
          state.imagesReady = true;
        }
      });
    }

    commit(announce = true) {
      // Normalize only settled integer positions, including negative loop indices.
      const rounded = Math.round(this.position);
      this.position = this.config.loop ? mod(rounded, this.count) : clamp(rounded, 0, this.count - 1);
      this.target = this.position;
      const nextIndex = this.position;
      const oldSlide = this.slides[this.active];
      if (nextIndex !== this.active && oldSlide?.contains(document.activeElement)) {
        this.stage.focus({ preventScroll: true });
      }
      this.active = nextIndex;
      this.slides.forEach((slide, index) => {
        const active = index === this.active;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        const card = this.cards[index];
        card.toggleAttribute('inert', !active);
        card.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach(node => {
          if (!this.tabStops.has(node)) this.tabStops.set(node, node.getAttribute('tabindex'));
          const original = this.tabStops.get(node);
          if (!active) node.setAttribute('tabindex', '-1');
          else if (original === null) node.removeAttribute('tabindex');
          else node.setAttribute('tabindex', original);
        });
      });
      this.dots.forEach(dot => {
        if (Number(dot.dataset.goto) === this.active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = String(this.active + 1).padStart(2, '0');
      if (this.progress) this.progress.style.transform = `scaleX(${(this.active + 1) / this.count})`;
      if (this.previous) this.previous.disabled = !this.config.loop && this.active === 0;
      if (this.next) this.next.disabled = !this.config.loop && this.active === this.count - 1;
      const title = this.slides[this.active].dataset.title || '';
      if (this.activeTitle) this.activeTitle.textContent = title;
      if (announce && this.status) {
        this.status.textContent = `${this.active + 1} ${this.dataset.labelOf || 'of'} ${this.count}: ${title}`;
      }
      this.paint();
      this.syncProductPreview();
      const activeDot = this.dots[this.active];
      const pagination = activeDot?.parentElement;
      if (pagination && pagination.scrollWidth > pagination.clientWidth) {
        const outer = pagination.getBoundingClientRect();
        const inner = activeDot.getBoundingClientRect();
        if (inner.left < outer.left) pagination.scrollLeft += inner.left - outer.left - 4;
        else if (inner.right > outer.right) pagination.scrollLeft += inner.right - outer.right + 4;
      }
    }

    stopAnimation() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.paintFrame);
      this.frame = 0;
      this.paintFrame = 0;
    }

    animate(destination, gesture = false) {
      if (!Number.isFinite(destination)) return;
      this.stopProductPreview();
      this.stopAnimation();
      this.resetGlow();
      destination = Math.round(destination);
      if (!this.circular) {
        destination = this.config.loop ? mod(destination, this.count) : clamp(destination, 0, this.count - 1);
      }
      this.target = destination;
      const from = this.position;
      const travel = Math.abs(destination - from);
      if (this.motion.matches || travel < 0.001) {
        this.position = destination;
        this.commit();
        return;
      }
      const start = performance.now();
      const configured = clamp(Number(this.config.duration) || 560, 200, 1200);
      // A swipe has already moved the cards. Its remaining settle should not
      // take another full, fixed-length button transition.
      const duration = gesture
        ? clamp(configured * 0.55 * Math.sqrt(clamp(travel, 0.25, 2)), 140, 320)
        : configured;
      const tick = now => {
        if (!this.isConnected || !this.initialized) { this.frame = 0; return; }
        const t = clamp((now - start) / duration, 0, 1);
        let eased;
        if (gesture || this.config.easing === 'snappy') eased = 1 - Math.pow(1 - t, 4);
        else if (this.config.easing === 'soft') eased = t * t * (3 - 2 * t);
        else eased = 1 - Math.pow(1 - t, 3);
        this.position = from + (destination - from) * eased;
        if (t < 1) {
          this.paint();
          this.frame = requestAnimationFrame(tick);
        } else {
          this.frame = 0;
          this.position = destination;
          this.commit();
        }
      };
      this.frame = requestAnimationFrame(tick);
      this.paint();
    }

    goTo(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.count) return;
      if (this.drag) this.clearDrag();
      let destination = index;
      if (this.circular) destination = this.position + this.distance(index);
      this.animate(destination);
    }

    step(delta) {
      if (this.count < 2 || !Number.isFinite(delta)) return;
      if (this.drag) this.clearDrag();
      this.animate(Math.round(this.target) + delta);
    }

    onClick(event) {
      const element = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!element) return;
      if (this.stage.contains(element) && event.detail !== 0 &&
          (this.drag?.moving || performance.now() < this.blockClickUntil)) {
        // Consume only the click generated by this drag. A new pointerdown
        // clears the guard, so a deliberate immediate tap is not blocked.
        this.blockClickUntil = 0;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const button = element.closest('[data-step], [data-goto], [data-select]');
      if (!button || !this.contains(button) || button.disabled) return;
      event.preventDefault();
      if (button.hasAttribute('data-step')) this.step(Number(button.dataset.step));
      else if (button.hasAttribute('data-goto')) this.goTo(Number(button.dataset.goto));
      else if (this.config.sideClick) {
        this.stage.focus({ preventScroll: true });
        this.goTo(Number(button.dataset.select));
      }
    }

    onKey(event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.defaultPrevented) return;
      if (event.target.closest('input, select, textarea, [contenteditable="true"]')) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); this.step(this.direction); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-this.direction); }
      else if (event.key === 'Home') { event.preventDefault(); this.goTo(0); }
      else if (event.key === 'End') { event.preventDefault(); this.goTo(this.count - 1); }
    }

    pointerDown(event) {
      if (!this.config.swipe || this.count < 2) return;

      if (!event.isPrimary) {
        if (this.drag && event.pointerType === 'touch') {
          this.pointerUp({ pointerId: this.drag.id }, true);
        }
        return;
      }

      if (event.button !== 0 || this.drag) return;

      const element = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!element) return;

      const control = element.closest(
        'button, input, select, textarea, summary, [contenteditable]:not([contenteditable="false"]), modal-opener, product-form'
      );

      // Preserve actual quick-add controls; the side-card selector can be dragged.
      if (control && !control.matches('.cs-select')) return;

      this.drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        start: this.position,
        base: Math.round(this.position),
        step: this.stepSize,
        direction: this.direction,
        lastX: event.clientX,
        lastTime: performance.now(),
        velocity: 0,
        dx: 0,
        moving: false,
        axis: null
      };

      this.dragLife = new AbortController();
      const options = { signal: this.dragLife.signal, capture: true };

      // Global listeners exist only while a pointer is down.
      // passive:false lets us prevent page movement after a horizontal swipe is confirmed.
      window.addEventListener('pointermove', e => this.pointerMove(e), { ...options, passive: false });
      window.addEventListener('pointerup', e => this.pointerUp(e), options);
      window.addEventListener('pointercancel', e => this.pointerUp(e, true), options);
    }

    pointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      if (event.type === 'pointermove' && event.pointerType === 'mouse' && (event.buttons & 1) === 0) {
        this.pointerUp(event, true);
        return;
      }

      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!Number.isFinite(dx) || !Number.isFinite(dy)) return;

      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      /*
       * Lock the gesture to one axis.
       *
       * Vertical gesture:
       *   stop carousel tracking and let the page scroll normally.
       *
       * Horizontal gesture:
       *   keep the page vertically fixed until the pointer is released.
       */
      if (!drag.axis) {
        const distance = Math.max(absX, absY);

        // Ignore tiny accidental finger movement.
        if (distance < 5) return;

        // Clearly vertical: hand control back to normal page scrolling.
        if (absY > absX * 1.15) {
          drag.axis = 'y';
          this.clearDrag();
          return;
        }

        // Clearly horizontal.
        if (absX > absY * 1.15) {
          drag.axis = 'x';
        } else {
          // Still diagonal/ambiguous. Wait a little longer before deciding.
          if (distance < 12) return;

          if (absX >= absY) {
            drag.axis = 'x';
          } else {
            drag.axis = 'y';
            this.clearDrag();
            return;
          }
        }

        // Horizontal swipe confirmed. Prevent the page from moving vertically.
        if (event.cancelable) event.preventDefault();

        drag.start = this.position;

        // Repeated swipes may interrupt the previous settle. Do not silently
        // send a second same-direction swipe to the first swipe's destination.
        drag.base = this.frame && Math.abs(this.target - drag.start) < 1.1
          ? Math.round(this.target)
          : Math.round(drag.start);

        drag.step = this.stepSize;
        drag.direction = this.direction;
        drag.moving = true;

        // Start momentum sampling only after the horizontal direction is confirmed.
        drag.lastX = event.clientX;
        drag.lastTime = performance.now();
        drag.velocity = 0;

        this.stopProductPreview();
        this.stopAnimation();
        this.resetGlow();
        this.target = this.position;
        this.setAttribute('data-dragging', '');

        try {
          this.stage.setPointerCapture(event.pointerId);
        } catch (_) {
          /* Pointer may already have ended. */
        }
      }

      if (drag.axis !== 'x') return;

      // Once horizontal dragging begins, keep the viewport vertically fixed.
      if (event.cancelable) event.preventDefault();

      const now = performance.now();
      const delta = event.clientX - drag.lastX;

      if (delta !== 0) {
        const elapsed = Math.max(4, now - drag.lastTime);
        const instantaneous = clamp(delta / elapsed, -3, 3);

        // Smooth momentum sampling to reduce touch jitter on mobile.
        drag.velocity = drag.velocity * 0.45 + instantaneous * 0.55;
        drag.lastX = event.clientX;
        drag.lastTime = now;
      }

      drag.dx = dx;

      let position = drag.start - dx / drag.step * drag.direction;

      if (!this.circular) {
        if (position < 0) {
          position = Math.max(-0.28, position * 0.25);
        } else if (position > this.count - 1) {
          position = Math.min(
            this.count - 0.72,
            this.count - 1 + (position - this.count + 1) * 0.25
          );
        }
      }

      this.position = position;

      // Paint at most once per animation frame.
      if (!this.paintFrame) {
        this.paintFrame = requestAnimationFrame(() => {
          this.paintFrame = 0;
          if (this.initialized) this.paint();
        });
      }
    }

    clearDrag() {
      const drag = this.drag;
      this.drag = null;
      this.dragLife?.abort();
      this.dragLife = null;
      this.removeAttribute('data-dragging');

      if (drag) {
        try {
          if (this.stage.hasPointerCapture(drag.id)) {
            this.stage.releasePointerCapture(drag.id);
          }
        } catch (_) {
          /* Capture can disappear when the browser cancels a gesture. */
        }
      }

      if (this.needsMeasure && this.isConnected) this.queueMeasure();
      return drag;
    }

    pointerUp(event, cancelled = false) {
      let drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      // Very short gestures can finish between animation frames. Include the
      // release coordinates instead of snapping from an older pointermove.
      if (!cancelled && Number.isFinite(event.clientX) && event.clientX !== drag.lastX) {
        this.pointerMove(event);
        drag = this.drag;
        if (!drag) return;
      }

      this.clearDrag();

      // Taps and vertical page gestures do not settle the carousel.
      if (!drag.moving) return;

      this.stopAnimation();
      this.blockClickUntil = performance.now() + 600;

      if (cancelled) {
        // Settle where the cards actually are, rather than jumping back to the
        // beginning of a potentially long, interrupted drag.
        this.animate(Math.round(this.position), true);
        return;
      }

      const recent = performance.now() - drag.lastTime < 100;
      const velocity = recent ? drag.velocity : 0;
      const momentum = this.config.momentum
        ? clamp(velocity, -2, 2) * 130 / drag.step * drag.direction
        : 0;

      let destination = Math.round(this.position - momentum);
      const threshold = clamp(drag.step * 0.10, 18, 36);
      const flick = this.config.momentum &&
        Math.abs(drag.dx) >= 12 &&
        Math.abs(velocity) >= 0.35;

      if (Math.abs(drag.dx) >= threshold || flick) {
        const direction = flick
          ? -Math.sign(velocity) * drag.direction
          : -Math.sign(drag.dx) * drag.direction;

        if (direction > 0) {
          destination = Math.max(destination, drag.base + 1);
        } else if (direction < 0) {
          destination = Math.min(destination, drag.base - 1);
        }
      }

      destination = clamp(destination, drag.base - 2, drag.base + 2);
      this.animate(destination, true);
    }

    settleImmediately() {
      if (!this.initialized) return;
      const position = this.drag?.moving ? this.position : this.target;
      this.clearDrag();
      this.stopAnimation();
      this.resetGlow();
      this.position = Math.round(position);
      this.commit(false);
    }

    onWheel(event) {
      if (!this.config.wheel || event.ctrlKey || this.count < 2 || this.drag) return;
      // Trackpads commonly emit many small deltas, not one large wheel tick.
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.stageWidth : 1;
      const dx = event.deltaX * unit;
      const dy = event.deltaY * unit;
      if (Math.abs(dx) < 0.01 || Math.abs(dx) <= Math.abs(dy) * 1.1) return;
      if (event.cancelable) event.preventDefault();
      const now = performance.now();
      const sign = Math.sign(dx);
      if (now - this.lastWheel > 160 || sign !== this.wheelSign) {
        this.wheelTotal = 0;
        this.wheelLocked = false;
      }
      this.lastWheel = now;
      this.wheelSign = sign;
      if (this.wheelLocked) return;
      this.wheelTotal += dx;
      if (Math.abs(this.wheelTotal) < 24) return;
      this.wheelLocked = true;
      this.animate(Math.round(this.target) + sign * this.direction, true);
    }

    resetGlow() {
      cancelAnimationFrame(this.glowFrame);
      this.glowFrame = 0;
      this.glow?.style.removeProperty('--cs-glow-x');
      this.glow?.style.removeProperty('--cs-glow-y');
    }

    followGlow(event) {
      if (!this.glow || !this.config.followPointer || !this.finePointer.matches ||
          this.motion.matches || this.frame || this.drag?.moving) return;
      this.glowPoint = { x: event.clientX, y: event.clientY };
      if (this.glowFrame) return;
      this.glowFrame = requestAnimationFrame(() => {
        this.glowFrame = 0;
        if (!this.isConnected || this.frame || this.drag?.moving) return;
        const rect = this.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = clamp((this.glowPoint.x - rect.left) / rect.width * 100, 20, 80);
        const y = clamp((this.glowPoint.y - rect.top) / rect.height * 100, 20, 70);
        // These properties belong on the glow, not on every descendant card.
        this.glow.style.setProperty('--cs-glow-x', `${x.toFixed(1)}%`);
        this.glow.style.setProperty('--cs-glow-y', `${y.toFixed(1)}%`);
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.bootFrame);
      this.stopProductPreview();
      this.clearDrag();
      this.resetGlow();
      this.life?.abort();
      this.markupObserver?.disconnect();
      this.markupObserver = null;
      this.resizeObserver?.disconnect();
      ['frame', 'paintFrame', 'resizeFrame', 'glowFrame'].forEach(key => cancelAnimationFrame(this[key]));
      this.drag = null;
      (this.modalRecords || []).forEach(({ modal, marker }) => {
        if (modal.hasAttribute('open') && typeof modal.hide === 'function') {
          try { modal.hide(true); } catch (_) { /* Theme-specific dialog cleanup. */ }
        }
        if (marker.parentNode) marker.replaceWith(modal);
        else modal.remove();
        delete modal.dataset.csOwner;
      });
      this.tabStops?.forEach((value, node) => {
        if (value === null) node.removeAttribute('tabindex');
        else node.setAttribute('tabindex', value);
      });
      (this.productPreviews || []).forEach(state => {
        if (!state) return;
        state.images.forEach(image => image.remove());
        state.dots[0]?.parentElement?.remove();
        state.base?.classList.remove('cs-product-preview-base');
        state.media?.querySelectorAll('.cs-product-preview-secondary').forEach(image => image.classList.remove('cs-product-preview-secondary'));
      });
      (this.cards || []).forEach(card => card.removeAttribute('inert'));
      (this.slides || []).forEach(slide => {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('style');
        slide.classList.remove('is-active', 'is-selectable', 'is-moving');
      });
      this.removeAttribute('data-ready');
      this.removeAttribute('data-dragging');
      this.removeAttribute('data-swipe');
      this.initialized = false;
    }
  }

  customElements.define('collection-studio', CollectionStudio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-media-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fo-video-background')) {
    customElements.define('fo-video-background', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.tryPlay = () => {
          const playback = this.video.play();
          if (playback && typeof playback.catch === 'function') {
            // Leave the video paused when the browser blocks autoplay.
            playback.catch(() => {});
          }
        };
        this.syncMotion = () => {
          if (this.motion.matches) this.video.pause();
          else this.tryPlay();
        };
        this.motion.addEventListener('change', this.syncMotion);
        this.syncMotion();
      }
      disconnectedCallback() {
        if (!this.video) return;
        this.motion.removeEventListener('change', this.syncMotion);
        this.video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.type = this.getAttribute('data-sticky-type') || 'none';
      this.overlay = this.dataset.overlay === 'true';
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.preventReveal = false;

      this.setHeaderHeight();
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      this.onScroll();
    }

    setHeaderHeight() {
      const height = this.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      const shell = this.closest('.lux-header-shell');
      if (shell && !shell.classList.contains('lux-header-shell--hero')) shell.style.setProperty('--lux-header-natural-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const down = scrollTop > this.currentScrollTop;
      const past = scrollTop > Math.max(18, this.offsetHeight * .3);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      this.classList.toggle('is-lux-scrolled', past);

      if (this.type === 'none') {
        this.classList.remove('is-lux-fixed', 'is-lux-hidden');
      } else if (this.type === 'always' || this.type === 'reduce-logo-size') {
        this.classList.toggle('is-lux-fixed', past || !this.overlay);
        this.classList.remove('is-lux-hidden');
      } else if (this.type === 'on-scroll-up') {
        if (!past) {
          this.classList.remove('is-lux-fixed', 'is-lux-hidden');
        } else if (down) {
          this.classList.add('is-lux-fixed', 'is-lux-hidden');
          this.closeMenuDisclosure();
          this.closeSearchModal();
        } else if (!this.preventReveal) {
          this.classList.add('is-lux-fixed');
          this.classList.remove('is-lux-hidden');
        }
      }

      this.currentScrollTop = Math.max(0, scrollTop);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close?.());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  class LuxHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-lux-slide]'));
      this.pagination = this.querySelector('[data-lux-pagination]');

      const showPagination = this.pagination?.dataset.enabled === 'true' && this.slides.length > 1;
      if (this.pagination && showPagination) {
        this.pagination.innerHTML = this.slides.map((_, index) => `
          <button
            type="button"
            class="lux-video-hero__dot"
            data-lux-dot
            data-index="${index}"
            aria-label="Show slide ${index + 1}"
            aria-current="false"
          ></button>
        `).join('');
        this.pagination.hidden = false;
      }

      this.dots = Array.from(this.querySelectorAll('[data-lux-dot]'));
      this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.interval = Math.max(2000, Number(this.dataset.interval) || 5000);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;

      this.onMouseEnter = () => this.stop();
      this.onMouseLeave = () => this.start();
      this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();

      this.dotHandlers = this.dots.map((dot, index) => {
        const handler = () => {
          this.goTo(index);
          this.restart();
        };
        dot.addEventListener('click', handler);
        return handler;
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
      }

      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.sync();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.pauseOnHover) {
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
      }
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.dots?.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
    }

    start() {
      if (!this.autoplay || this.reduceMotion || this.slides.length <= 1 || this.timer || document.hidden) return;
      this.timer = window.setInterval(() => this.goTo(this.current + 1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    goTo(index) {
      if (this.slides.length <= 1) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.sync();
    }

    sync() {
      this.slides.forEach((slide, index) => {
        const active = index === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === this.current ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('lux-hero-slideshow')) customElements.define('lux-hero-slideshow', LuxHeroSlideshow);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["together-pair"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('together-pair-swipe')) return;
  let cartWriteInProgress = false;
  const normalizeSize = value => String(value || '').trim().toLocaleLowerCase();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  class TogetherPairSwipe extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (!this.isConnected || this.initialized) return;
      if (!this.querySelector('[data-tp-end]')) {
        this.observer = this.observer || new MutationObserver(() => {
          if (this.querySelector('[data-tp-end]')) this.init();
        });
        this.observer.observe(this, { childList:true, subtree:true });
        return;
      }
      this.observer?.disconnect();
      try { this.config = JSON.parse(this.querySelector('[data-tp-config]').textContent); }
      catch (error) { console.warn('Together Pair could not initialize.', error); return; }
      this.products = (this.config.products || []).filter(product =>
        Array.isArray(product.variants) && product.variants.length >= 1 && product.variants.length <= 2 &&
        product.variants.every(variant => normalizeSize(variant.size) && variant.id) &&
        new Set(product.variants.map(variant => normalizeSize(variant.size))).size === product.variants.length
      );
      this.button = this.querySelector('[data-tp-add]');
      this.buttonLabel = this.querySelector('[data-tp-button-label]');
      this.status = this.querySelector('[data-tp-status]');
      this.review = this.querySelector('[data-tp-review]');
      this.life = new AbortController();
      this.initialized = true;
      this.busy = !!this.busy;
      this.needsReview = !!this.needsReview;
      this.navigating = !!this.navigating;
      this.rtl = getComputedStyle(this).direction === 'rtl';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const prior = (this.slots || []).map(slot => ({ productId:slot.product?.id, size:slot.sizePreference }));
      this.slots = Array.from(this.querySelectorAll('[data-tp-slot]')).map((node, number) => ({
        node, number,
        gallery:node.querySelector('[data-tp-gallery]'),
        previous:node.querySelector('[data-tp-previous]'),
        next:node.querySelector('[data-tp-next]'),
        title:node.querySelector('[data-tp-title]'),
        sizes:node.querySelector('[data-tp-sizes]'),
        announcement:node.querySelector('[data-tp-announcement]'),
        sizePreference:prior[number]?.size || null,
        index:0, targetIndex:null, moving:false, drag:null, width:0
      }));
      const on = (target, type, callback, options = {}) => {
        target.addEventListener(type, callback, { ...options, signal:this.life.signal });
      };
      if (!this.products.length) {
        this.button.disabled = true;
        this.slots.forEach(slot => { slot.node.disabled = true; slot.gallery.tabIndex = -1; });
        this.status.textContent = this.config.labels.empty;
        return;
      }
      const inStock = this.products.filter(product => product.variants.some(variant => this.available(variant)));
      this.slots.forEach((slot, number) => {
        const seedPlaceholder = slot.gallery.querySelector('.tpm-photo-placeholder');
        slot.slides = this.products.map((product, index) => {
          const node = document.createElement('div');
          node.className = 'tpm-slide';
          node.setAttribute('role', 'group');
          node.setAttribute('aria-roledescription', 'slide');
          node.setAttribute('aria-label', `${index + 1} / ${this.products.length}: ${product.title}`);
          const image = document.createElement('img');
          image.className = 'tpm-product-image';
          image.width = 900; image.height = 900;
          image.loading = 'lazy'; image.decoding = 'async'; image.draggable = false;
          const placeholder = seedPlaceholder.cloneNode(true);
          placeholder.hidden = true;
          node.append(image, placeholder);
          const slide = { node, image, placeholder, source:null };
          on(image, 'error', () => { image.hidden = true; placeholder.hidden = false; });
          on(image, 'load', () => { image.hidden = false; placeholder.hidden = true; });
          this.paintImage(slide, product.image || product.variants.find(v => v.image)?.image, product.title);
          return slide;
        });
        slot.gallery.replaceChildren(...slot.slides.map(slide => slide.node));
        slot.gallery.toggleAttribute('data-multiple', this.products.length > 1);
        slot.node.querySelector('.tpm-design-nav').hidden = this.products.length < 2;
        slot.gallery.tabIndex = this.products.length > 1 ? 0 : -1;
        const initial = this.products.find(p => p.id === prior[number]?.productId)
          || inStock[number] || inStock[0] || this.products[number] || this.products[0];
        this.selectDesign(slot, this.products.indexOf(initial), false);
        this.align(slot);
        on(slot.gallery, 'scroll', () => this.onScroll(slot), { passive:true });
        on(slot.gallery, 'scrollend', () => this.settle(slot), { passive:true });
        on(slot.gallery, 'pointerdown', event => this.startDrag(slot, event));
        on(slot.gallery, 'dragstart', event => event.preventDefault());
        on(slot.gallery, 'keydown', event => {
          if (this.locked()) return;
          let target;
          const current = slot.targetIndex ?? slot.index;
          if (event.key === 'ArrowRight') target = current + (this.rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') target = current + (this.rtl ? 1 : -1);
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this.products.length - 1;
          else return;
          event.preventDefault();
          this.goTo(slot, target);
        });
        on(slot.previous, 'click', () => this.goTo(slot, (slot.targetIndex ?? slot.index) - 1));
        on(slot.next, 'click', () => this.goTo(slot, (slot.targetIndex ?? slot.index) + 1));
        on(slot.sizes, 'click', event => {
          const button = event.target.closest('[data-tp-size-id]');
          if (!button || button.disabled || this.locked() || slot.moving) return;
          const variant = slot.product.variants.find(v => v.id === button.dataset.tpSizeId);
          if (!this.available(variant)) return;
          slot.variantId = variant.id;
          if (slot.product.variants.length > 1) slot.sizePreference = variant.size;
          this.paintSelection(slot);
          this.announce(slot);
          this.update();
        });
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const slot = this.slots.find(item => item.gallery === entry.target);
            if (!slot || slot.drag) return;
            const width = slot.slides[0].node.getBoundingClientRect().width;
            if (Math.abs(width - slot.width) > 0.1) this.align(slot);
          });
        });
        this.slots.forEach(slot => this.resizeObserver.observe(slot.gallery));
      } else {
        on(window, 'resize', () => this.slots.forEach(slot => this.align(slot)));
      }
      on(this.button, 'click', () => this.addPair());
      on(window, 'pageshow', event => {
        if (event.persisted && !this.busy) { this.navigating = false; this.update(); }
      });
      on(window, 'blur', () => this.slots.forEach(slot => this.finishDrag(slot)));
      this.setAttribute('data-ready', '');
      this.update();
    }

    locked() { return this.busy || this.needsReview || this.navigating; }
    available(variant) { return !!variant && variant.available && Number(variant.stockLimit) > 0; }
    variant(slot) { return slot.product?.variants.find(variant => variant.id === slot.variantId); }

    paintImage(slide, source, alt) {
      slide.image.alt = alt;
      if (!source) {
        slide.image.hidden = true; slide.placeholder.hidden = false;
        slide.image.removeAttribute('src'); slide.image.removeAttribute('srcset'); slide.source = null;
        return;
      }
      const url = new URL(source, document.baseURI);
      if (slide.source === url.href) return;
      slide.source = url.href;
      slide.image.hidden = false;
      slide.placeholder.hidden = true;
      slide.image.sizes = '(min-width: 1200px) 300px, (min-width: 900px) 24vw, (min-width: 750px) 30vw, 44vw';
      slide.image.srcset = url.protocol === 'data:' ? '' : [240,360,540,720,900].map(width => {
        const resized = new URL(url.href);
        resized.searchParams.set('width', String(width));
        return `${resized.href} ${width}w`;
      }).join(', ');
      slide.image.src = url.href;
    }

    selectDesign(slot, index, announce = true) {
      slot.index = clamp(index, 0, this.products.length - 1);
      slot.product = this.products[slot.index];
      // A one-size product always selects its only option, including a sold-out
      // option (which stays disabled). Keep the remembered two-size preference
      // separate, so returning to a two-size product restores it without silently
      // switching to a different size to enable the cart button.
      const singleSize = slot.product.variants.length === 1;
      const variant = singleSize
        ? slot.product.variants[0]
        : slot.sizePreference
          ? slot.product.variants.find(v => normalizeSize(v.size) === normalizeSize(slot.sizePreference))
          : slot.product.variants.find(v => this.available(v)) || slot.product.variants[0];
      slot.variantId = variant?.id || null;
      if (!singleSize && !slot.sizePreference && variant) slot.sizePreference = variant.size;
      slot.title.textContent = slot.product.title;
      slot.title.title = slot.product.title;
      slot.sizes.setAttribute('aria-label', `${slot.product.sizeName || this.config.labels.size}: ${this.config.slotNames[slot.number]}`);
      slot.sizes.replaceChildren(...slot.product.variants.map(v => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'tpm-size';
        button.dataset.tpSizeId = v.id;
        button.textContent = v.size;
        button.setAttribute('aria-label', `${v.size}${this.available(v) ? '' : ` - ${this.config.labels.soldOut}`}`);
        return button;
      }));
      slot.slides.forEach((slide, i) => slide.node.setAttribute('aria-hidden', String(i !== slot.index)));
      this.paintSelection(slot);
      if (announce) this.announce(slot);
    }

    paintSelection(slot) {
      const variant = this.variant(slot);
      slot.sizes.querySelectorAll('[data-tp-size-id]').forEach(button => {
        const option = slot.product.variants.find(v => v.id === button.dataset.tpSizeId);
        button.setAttribute('aria-pressed', String(option.id === slot.variantId));
        button.toggleAttribute('data-unavailable', !this.available(option));
        button.disabled = this.locked() || slot.moving || !this.available(option);
      });
      this.paintImage(slot.slides[slot.index], variant?.image || slot.product.image,
        `${slot.product.title}${variant ? ` - ${variant.size}` : ''}`);
    }

    announce(slot) {
      const variant = this.variant(slot);
      slot.announcement.textContent = `${this.config.slotNames[slot.number]}: ${slot.product.title}${variant ? `, ${variant.size}` : ''}`;
    }

    align(slot) {
      slot.width = slot.slides[0].node.getBoundingClientRect().width;
      slot.gallery.scrollTo({ left:(this.rtl ? -1 : 1) * slot.index * slot.width, behavior:'instant' });
    }

    goTo(slot, index) {
      if (this.locked() || this.products.length < 2) return;
      slot.targetIndex = clamp(index, 0, this.products.length - 1);
      slot.width = slot.slides[0].node.getBoundingClientRect().width;
      slot.moving = true;
      this.update();
      slot.gallery.scrollTo({
        left:(this.rtl ? -1 : 1) * slot.targetIndex * slot.width,
        behavior:this.reducedMotion.matches ? 'instant' : 'smooth'
      });
      clearTimeout(slot.settleTimer);
      // The fallback also handles already-at-target and hidden-section cases.
      slot.settleTimer = setTimeout(() => this.settle(slot), 240);
    }

    syncSlot(slot) {
      if (this.locked() || !slot.width) return;
      // A breakpoint may change native scrollLeft before ResizeObserver runs.
      // Do not interpret that reflow as a shopper choosing another design.
      const measuredWidth = slot.slides[0].node.getBoundingClientRect().width;
      if (Math.abs(measuredWidth - slot.width) > 0.1) {
        this.align(slot);
        return;
      }
      const index = clamp(Math.round(Math.abs(slot.gallery.scrollLeft) / slot.width), 0, this.products.length - 1);
      if (index !== slot.index) this.selectDesign(slot, index, false);
    }

    onScroll(slot) {
      if (this.locked()) return;
      slot.moving = true;
      cancelAnimationFrame(slot.scrollFrame);
      slot.scrollFrame = requestAnimationFrame(() => { this.syncSlot(slot); this.update(); });
      clearTimeout(slot.settleTimer);
      slot.settleTimer = setTimeout(() => this.settle(slot), 160);
    }

    settle(slot) {
      if (!this.isConnected || slot.drag) return;
      clearTimeout(slot.settleTimer);
      cancelAnimationFrame(slot.scrollFrame);
      this.syncSlot(slot);
      slot.moving = false;
      slot.targetIndex = null;
      this.announce(slot);
      this.update();
    }

    startDrag(slot, event) {
      // Touch and trackpads use native scrolling, which keeps vertical page
      // scrolling and pinch-to-zoom intact. Only mouse dragging is scripted.
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.locked() || this.products.length < 2) return;
      this.finishDrag(slot);
      slot.width = slot.slides[0].node.getBoundingClientRect().width;
      // A fresh press can interrupt a smooth arrow transition.
      slot.gallery.scrollTo({ left:slot.gallery.scrollLeft, behavior:'instant' });
      slot.targetIndex = null;
      slot.drag = { pointerId:event.pointerId, x:event.clientX, y:event.clientY, left:slot.gallery.scrollLeft, active:false };
      slot.dragLife = new AbortController();
      const options = { signal:slot.dragLife.signal };
      const move = moveEvent => {
        const drag = slot.drag;
        if (!drag || moveEvent.pointerId !== drag.pointerId) return;
        const dx = moveEvent.clientX - drag.x;
        const dy = moveEvent.clientY - drag.y;
        if (!drag.active) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.finishDrag(slot); return; }
          drag.active = true;
          slot.gallery.setAttribute('data-dragging', '');
          slot.gallery.setPointerCapture?.(drag.pointerId);
          slot.moving = true;
          this.update();
        }
        moveEvent.preventDefault();
        slot.gallery.scrollLeft = drag.left - dx;
      };
      window.addEventListener('pointermove', move, { ...options, passive:false });
      window.addEventListener('pointerup', e => { if (e.pointerId === slot.drag?.pointerId) this.finishDrag(slot); }, options);
      window.addEventListener('pointercancel', e => { if (e.pointerId === slot.drag?.pointerId) this.finishDrag(slot); }, options);
      slot.gallery.addEventListener('lostpointercapture', () => this.finishDrag(slot), options);
    }

    finishDrag(slot) {
      const drag = slot.drag;
      if (!drag) return;
      slot.drag = null;
      slot.dragLife?.abort();
      if (slot.gallery.hasPointerCapture?.(drag.pointerId)) slot.gallery.releasePointerCapture(drag.pointerId);
      const target = clamp(Math.round(Math.abs(slot.gallery.scrollLeft) / (slot.width || 1)), 0, this.products.length - 1);
      slot.gallery.removeAttribute('data-dragging');
      if (drag.active) this.goTo(slot, target);
      else if (slot.moving) this.settle(slot);
    }

    selectionError() {
      const variants = this.slots.map(slot => this.variant(slot));
      if (variants.length !== 2 || variants.some(v => !v)) return this.config.labels.missingSize;
      if (variants.some(v => !this.available(v))) return this.config.labels.noPair;
      if (variants[0].id === variants[1].id && Number(variants[0].stockLimit) < 2) return this.config.labels.oneLeft;
      return '';
    }

    update() {
      const error = this.selectionError();
      const moving = this.slots.some(slot => slot.moving || slot.drag?.active);
      const locked = this.locked();
      this.button.disabled = locked || moving || !!error;
      this.buttonLabel.textContent = this.busy ? this.config.labels.adding : this.needsReview ? this.config.labels.review : this.config.button;
      if (!this.busy && !this.needsReview) this.status.textContent = moving ? '' : error;
      this.slots.forEach(slot => {
        slot.node.disabled = locked;
        slot.gallery.inert = locked;
        slot.gallery.toggleAttribute('data-locked', locked);
        slot.gallery.tabIndex = locked || this.products.length < 2 ? -1 : 0;
        slot.previous.disabled = locked || (slot.targetIndex ?? slot.index) <= 0;
        slot.next.disabled = locked || (slot.targetIndex ?? slot.index) >= this.products.length - 1;
        slot.sizes.querySelectorAll('[data-tp-size-id]').forEach(button => {
          const variant = slot.product.variants.find(v => v.id === button.dataset.tpSizeId);
          button.disabled = locked || slot.moving || !this.available(variant);
        });
      });
    }

    async addPair() {
      if (this.locked() || this.slots.some(slot => slot.moving || slot.drag)) return;
      const error = this.selectionError();
      if (error) { this.status.textContent = error; return; }
      if (cartWriteInProgress) { this.status.textContent = this.config.labels.busy; return; }
      const grouped = new Map();
      this.slots.forEach(slot => {
        const id = this.variant(slot).id;
        grouped.set(id, (grouped.get(id) || 0) + 1);
      });
      const payload = { items:Array.from(grouped, ([id, quantity]) => ({ id, quantity })) };
      let drawer = this.config.drawer ? document.querySelector('cart-drawer') : null;
      if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') drawer = null;
      if (drawer) {
        try {
          const sections = drawer.getSectionsToRender().map(part => part.id).filter(Boolean).slice(0,5);
          if (!sections.length) drawer = null;
          else {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.button);
          }
        } catch (_) { drawer = null; delete payload.sections; delete payload.sections_url; }
      }
      this.busy = true;
      cartWriteInProgress = true;
      this.setAttribute('data-busy', '');
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.review.hidden = true;
      this.update();
      let submitted = false;
      let confirmed = false;
      try {
        // No timeout, retry, or abort after dispatch: an aborted request can
        // still write to Shopify, and retrying could duplicate a customer's pair.
        submitted = true;
        const response = await fetch(this.config.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body:JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const detail = typeof data.description === 'string' ? data.description : '';
          throw new Error(detail ? `${detail} ${this.config.labels.error}` : this.config.labels.error);
        }
        if (!Array.isArray(data.items) || !payload.items.every(item => data.items.filter(added => String(added.variant_id || added.id) === item.id).reduce((sum, added) => sum + Number(added.quantity || 0), 0) >= item.quantity)) {
          throw new Error(this.config.labels.error);
        }
        confirmed = true;
        this.dispatchEvent(new CustomEvent('together:added', {
          bubbles:true, detail:{ items:payload.items, response:data }
        }));
        // Rendering problems must NEVER resubmit the already-successful add.
        if (drawer && data.sections && payload.sections.every(id => typeof data.sections[id] === 'string')) {
          try {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
            if (this.isConnected) {
              this.busy = false;
              this.update();
              this.status.textContent = this.config.labels.added;
              this.review.hidden = false;
            }
            return;
          } catch (_) { /* The full cart is a safe fallback. */ }
        }
        this.navigating = true;
        window.location.assign(this.config.cartUrl);
      } catch (failure) {
        if (confirmed) {
          this.navigating = true;
          window.location.assign(this.config.cartUrl);
          return;
        }
        if (this.isConnected) {
          // Shopify can partially adjust inventory on error. Ask the buyer to
          // review their existing cart rather than offering a blind retry.
          this.needsReview = submitted;
          this.status.textContent = failure instanceof Error && failure.message && failure.message !== 'Failed to fetch'
            ? failure.message : this.config.labels.error;
          if (!this.status.textContent.includes(this.config.labels.error)) this.status.textContent += ` ${this.config.labels.error}`;
          this.review.hidden = false;
          this.review.focus({ preventScroll:true });
        }
      } finally {
        cartWriteInProgress = false;
        this.busy = false;
        if (this.isConnected) {
          this.removeAttribute('data-busy');
          this.button.removeAttribute('aria-busy');
          // Keep the error/success message when restoring input states.
          const message = this.status.textContent;
          this.update();
          this.status.textContent = message;
        }
      }
    }


    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.life?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      (this.slots || []).forEach(slot => {
        clearTimeout(slot.settleTimer);
        cancelAnimationFrame(slot.scrollFrame);
        slot.dragLife?.abort();
        if (slot.drag && slot.gallery.hasPointerCapture?.(slot.drag.pointerId)) {
          slot.gallery.releasePointerCapture(slot.drag.pointerId);
        }
        slot.gallery.removeAttribute('data-dragging');
        slot.drag = null;
      });
      this.initialized = false;
      // Never abort an in-flight write that may already have reached Shopify.
    }
  }
  customElements.define('together-pair-swipe', TogetherPairSwipe);
})();

  } catch(e) { console.error(e); }
})();
})();
